<template>
  <v-text-field v-model="lazyValue" ref="dateTimeEditorField" v-bind="cptProps" v-on="cptOn">
    <template v-slot:prepend-inner>
      <v-menu :activator="$refs.dateTimeEditorField" v-model="visible" :open-on-click="false" :close-on-click="false" transition="scale-transition" :close-on-content-click="false" max-width="290" offset-y>
        <v-date-picker v-model="lazyDate" locale="zh" :day-format="(e)=>parseInt(new Date(e).getDate())">
          <mini-text-editor width="26" placeholder="时" v-model="lazyTime[0]"></mini-text-editor>
          <span class="ml-1 mr-1">:</span>
          <mini-text-editor width="26" placeholder="分" v-model="lazyTime[1]"></mini-text-editor>
          <span class="ml-1 mr-1">:</span>
          <mini-text-editor width="26" placeholder="秒" v-model="lazyTime[2]"></mini-text-editor>
          <v-spacer />
          <v-btn color="primary" small @click="onOk">确定</v-btn>
          <v-btn color="primary" text small @click="onOkNow">现在</v-btn>
          <v-btn color="primary" text small @click="onCancel">取消</v-btn>
        </v-date-picker>
      </v-menu>
    </template>
  </v-text-field>

</template>
<script>
import EditorProps from '../EditorProps';
export default {
  props: { ...EditorProps.custom, ...EditorProps.vuetify },
  data () {
    return {
      visible: false,
      lazyValue: null,
      oldValue: null,

      lazyDate: null,
      lazyTime: ['', '', '']
    }
  },
  watch: {
    value (v1) { // YMDHMS
      this.oldValue = v1;
      this.decodeValue(v1);
    }
  },
  computed: {
    cptProps () {
      return {
        dense: this.dense, 'hide-details': this.hideDetails, disabled: this.disabled, label: this.label,
        outlined: this.outlined,
        clearable: !this.required,
        'append-icon': 'mdi-calendar-text-outline'
      }
    },
    cptOn () {
      return {
        input: () => { },
        'click:append': this.onClickAppend,
        blur: this.onBlur,
        'click:clear': this.onClear
      }
    }
  },
  methods: {
    onClickAppend () {
      this.visible = true;
      if (!this.lazyDate) {
        let now = this.Utility.now();
        let now2 = this.Utility.fmtDt(now);
        this.decodeValue(now2);
      }
    },
    validate (v) {
      let exp = /^(?:19|20)[0-9][0-9]-(?:(?:0[1-9])|(?:1[0-2]))-(?:(?:[0-2][1-9])|(?:[1-3][0-1])) (?:(?:[0-2][0-3])|(?:[0-1][0-9])):[0-5][0-9]:[0-5][0-9]$/;
      return exp.test(v);
    },
    onBlur () {
      if (this.visible) return;
      if (this.lazyValue) {
        if (!this.validate(this.lazyValue)) this.lazyValue = null;
        this.decodeValue(this.lazyValue);
      }
      this.triggerChange();
    },
    onClear () {
      this.lazyValue = null;
      this.decodeValue();
      this.triggerChange();
    },
    triggerChange () {
      this.$emit('input', this.lazyValue);
      this.$emit('change', this.lazyValue);
      this.oldValue = this.lazyValue;
    },
    onOk () {
      let value = this.lazyDate + ' ' + this.lazyTime.join(':');
      if (!this.validate(value)) {
        this.$message.alert('输入格式不合法[yyyy-MM-dd HH:mm:ss]');
        return;
      }
      this.lazyValue = value;
      this.visible = false;
    },
    onOkNow () {
      let now = this.Utility.now();
      this.lazyValue = this.Utility.fmtDt(now);
      this.decodeValue(this.lazyValue);
      this.triggerChange();
      this.visible = false;
    },
    onCancel () {
      this.visible = false;
    },

    decodeValue (v) {
      if (!v) {
        this.lazyDate = null;
        this.lazyTime = ['', '', ''];
      } else {
        let parts = v.split(' ');
        this.lazyDate = parts[0].trim();
        this.lazyTime = parts[1].trim().split(':');
      }
    }
  }
}
</script>